import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  ModalContainer,
  KeyboardView,
  Copy,
  Bold,
  Title,
  Icon,
  Row,
  Spin,
  Card,
  Button,
  Scroll
} from "app/NativeComponents/common";
import { Header, PillButton } from "app/NativeComponents/snippets";

import {
  appRedirect,
  getMultiSendNumbers,
  getMultiSendNumbersCount,
  sendMultiSendMessage,
  skipMultiSendNumber,
  updateLead,
  updateOwnerInfo,
  getConversations,
  setModal,
  toggleModal,
  skipTrace
} from "app/NativeActions";

import OnboardingText from "app/DealMachineCore/snippets/OnboardingText";
import SendMessage from "./SendMessage";
import KeyboardAwarePanel from "app/NativeComponents/components/KeyboardAwarePanel";

import moment from "moment";

class MultiSendNumbers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      started_sending: false,
      sending_over: false,
      lead_ids: props.multisend_filters ? props.multisend_filters.lead_ids : "",
      filters: props.multisend_filters ? props.multisend_filters.filters : {},
      filter_lists: props.multisend_filters
        ? props.multisend_filters.filter_lists
        : [],
      total_property_count: props.multisend_filters
        ? props.multisend_filters.total_property_count
        : props.user
        ? props.user.total_leads_count
        : 0,
      create_list: true,
      new_list_name: `New Conversations Started on ${moment().format(
        "M/DD/YYYY [@] h:mm a"
      )}`,
      multisend_number: null,
      current_message_text: "",
      selected_from_number: null,

      selected_replies: []
    };

    this.startSending = this.startSending.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.updateCurrentMessageText = this.updateCurrentMessageText.bind(this);
    this.updateCurrentFromNumber = this.updateCurrentFromNumber.bind(this);
  }

  getTeamNumberGroup(
    team_phone_number_groups,
    team_phone_number_group_id = null
  ) {
    if (team_phone_number_groups.length > 0) {
      for (let i = 0; i < team_phone_number_groups.length; i++) {
        if (
          team_phone_number_group_id &&
          team_phone_number_group_id == team_phone_number_groups[i].id
        ) {
          return team_phone_number_groups[i];
        }

        if (team_phone_number_groups[i].default_number == 1) {
          return team_phone_number_groups[i];
        }
      }

      return team_phone_number_groups[0];
    }
    return null;
  }

  componentDidMount() {
    this.getNumbers({ load_type: "load", begin: 0 });
    this.props.getMultiSendNumbersCount({
      token: this.props.token,
      lead_ids: this.state.lead_ids,
      filters: this.state.filters,
      filter_lists: this.state.filter_lists
    });
  }

  getNumbers({ load_type = "load", begin = 0 }) {
    if (!this.props.multisend_numbers_loading) {
      this.props.getMultiSendNumbers({
        token: this.props.token,
        load_type,
        begin,
        lead_ids: this.state.lead_ids,
        filters: this.state.filters,
        filter_lists: this.state.filter_lists
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (!this.state.sending_over &&
        !prevState.multisend_number &&
        this.props.multisend_numbers.length > 0) ||
      (this.state.started_sending &&
        !prevState.started_sending &&
        this.props.multisend_numbers.length > 0) ||
      (prevProps.multisend_numbers &&
        prevProps.multisend_numbers.length > 0 &&
        this.props.multisend_numbers &&
        this.props.multisend_numbers.length > 0 &&
        prevProps.multisend_numbers[0].id != this.props.multisend_numbers[0].id)
    ) {
      this.setState({
        multisend_number: this.props.multisend_numbers[0],
        current_message_text: this.generateRandomReply(),
        selected_from_number: this.props.multisend_numbers[0].team_phone_number
          ? this.getTeamNumberGroup(
              this.props.team_phone_number_groups,
              this.props.multisend_numbers[0].team_phone_number
                .team_phone_number_group_id
            )
          : this.props.team_phone_number_groups &&
            this.props.team_phone_number_groups.length
          ? this.getTeamNumberGroup(this.props.team_phone_number_groups)
          : null
      });
    }

    if (prevProps.starting_responses != this.props.starting_responses) {
      this.setState({
        selected_replies: this.props.starting_responses
      });
    }

    if (
      prevProps.multisend_numbers.length > 0 &&
      this.props.multisend_numbers.length == 0 &&
      !this.props.multisend_numbers_loading &&
      this.props.multisend_numbers_loaded_all &&
      !this.state.sending_over
    ) {
      this.setState({
        sending_over: true,
        multisend_number: null,
        current_message_text: "",
        selected_from_number: null
      });
    }

    if (
      prevProps.multisend_numbers &&
      this.props.multisend_numbers &&
      !this.state.sending_over &&
      !this.props.multisend_numbers_loaded_all &&
      prevProps.multisend_numbers.length > 0 &&
      this.props.multisend_numbers.length > 0 &&
      prevProps.multisend_numbers.length !==
        this.props.multisend_numbers.length &&
      this.props.multisend_numbers.length <=
        parseInt(this.props.multisend_numbers_limit / 1.33) &&
      !this.props.multisend_numbers_loading
    ) {
      this.getNumbers({
        begin: this.props.multisend_numbers_begin,
        load_type: "load_more"
      });
    }
  }

  handleBack() {
    this.props.appRedirect({
      redirect: "goBack",
      payload: { remove: "send-text-messages" }
    });
  }

  renderExplainingText() {
    if (!this.state.started_sending) {
      return (
        <Wrapper>
          <OnboardingText
            slug="multisendNumbers"
            center={false}
            style={{ padding: 20, paddingBottom: 0 }}
            titleStyle={{ paddingBottom: 20 }}
          />
          {this.renderPhoneNumberCount()}
        </Wrapper>
      );
    }
  }

  renderPhoneNumberCount() {
    if (!this.props.multisend_count_loading) {
      return (
        <Wrapper
          style={{ padding: 20, paddingTop: this.props.isMobile ? 0 : 20 }}
        >
          <Copy style={{ textAlign: this.props.isMobile ? "center" : "left" }}>
            <Bold>
              {"Retrieved "}
              {this.props.multisend_total == 1
                ? "1 Number"
                : this.props.multisend_total + " Numbers"}
              {" For "}
              {this.props.total_property_count == 1
                ? "1 Selected Lead"
                : this.state.total_property_count + " Selected Leads."}
            </Bold>
          </Copy>
          <Copy style={{ textAlign: this.props.isMobile ? "center" : "left" }}>
            This excludes blocked numbers, numbers on the "Do Not Call" list,
            numbers marked as "wrong", and landlines.
          </Copy>
          <Copy
            style={{
              textAlign: this.props.isMobile ? "center" : "left",
              marginTop: 10
            }}
          >
            If there are any leads that need to be skip traced you'll need to do
            so beforehand.
          </Copy>
        </Wrapper>
      );
    }
  }

  renderCompleteText() {
    if (this.state.sending_over) {
      return (
        <Wrapper
          style={{
            padding: 20,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Row style={{ alignItems: "center", justifyContent: "center" }}>
            <Icon
              color={this.props.colors.success_color}
              size={32}
              icon="check-circle"
              style={{ marginRight: 10 }}
            />
            <Title>You're all set!</Title>
          </Row>
          <Copy style={{ textAlign: "center", padding: 10 }}>
            View responses from your leads on the next page as they come in.
          </Copy>
          <Row style={{ justifyContent: "center" }}>
            <PillButton
              primary={true}
              onPress={() => {
                this.props.getConversations({
                  token: this.props.token,
                  load_type: "load",
                  search: this.props.conversations_search,
                  filter_type: this.props.conversations_filters
                    ? this.props.conversations_filters.filter_type
                    : "",
                  sort_by: this.props.conversations_filters
                    ? this.props.conversations_filters.sort_by
                    : "",
                  begin: 0,
                  limit: this.props.conversations_limit
                });
                this.props.appRedirect({
                  redirect: "message_engine"
                });
              }}
            >
              Go To Conversations
            </PillButton>
            <PillButton
              primary={false}
              onPress={this.handleBack}
              style={{ marginLeft: 0 }}
            >
              Dismiss
            </PillButton>
          </Row>
        </Wrapper>
      );
    }
  }

  startSending() {
    this.setState({
      started_sending: true
    });

    if (this.state.create_list && this.state.total_property_count > 1) {
      this.props.updateLead({
        new_list_name: this.state.new_list_name,
        token: this.props.token,
        type: "add_leads_to_lists_from_messages",
        list_ids: "",
        select_all: !!this.state.lead_ids ? false : true,
        total_count: this.state.total_property_count,
        filters: this.state.filters,
        filter_lists: this.state.filter_lists,
        deal_ids: this.state.lead_ids,
        onSuccess: () => {},
        no_loading: true
      });
    }
  }

  updateCurrentMessageText(value) {
    this.setState({
      current_message_text: value
    });
  }
  updateCurrentFromNumber(phone_number) {
    this.setState({
      selected_from_number: phone_number
    });
  }

  generateRandomReply() {
    const { selected_replies } = this.state;
    if (selected_replies.length > 0) {
      const random_reply =
        selected_replies[Math.floor(Math.random() * selected_replies.length)];

      return random_reply ? random_reply.response_text : "";
    }
    return "";
  }

  isChecked(reply) {
    for (let i = 0; i < this.state.selected_replies.length; i++) {
      if (this.state.selected_replies[i].id === reply.id) {
        return true;
      }
    }

    return false;
  }

  checkReply(reply) {
    let found_reply = false;
    for (let i = 0; i < this.state.selected_replies.length; i++) {
      if (this.state.selected_replies[i].id === reply.id) {
        found_reply = true;
      }
    }
    if (found_reply) {
      this.setState({
        selected_replies: this.state.selected_replies.filter(
          ({ id }) => id !== reply.id
        )
      });
    } else {
      this.setState({
        selected_replies: [...this.state.selected_replies, reply]
      });
    }
  }

  renderSpamLabel(saved_reply) {
    const { colors } = this.props;
    if (
      saved_reply.spam &&
      saved_reply.starting_response &&
      !saved_reply.spam.valid &&
      saved_reply.spam.phrases &&
      saved_reply.spam.phrases.length > 0
    ) {
      let spam_phrases = "";
      for (let i = 0; i < saved_reply.spam.phrases.length; i++) {
        if (spam_phrases.length == 0) {
          spam_phrases += saved_reply.spam.phrases[i];
        } else {
          spam_phrases += "," + saved_reply.spam.phrases[i];
        }
      }
      return (
        <Row>
          <Wrapper
            style={{
              backgroundColor: colors.yellow_card_color_muted,
              borderRadius: 15,
              padding: 3,
              paddingLeft: 10,
              paddingRight: 10,
              marginTop: 5
            }}
          >
            <Copy>Flagged As Spam (Remove the following: {spam_phrases})</Copy>
          </Wrapper>
        </Row>
      );
    }
  }

  renderSelectMessages() {
    const {
      multisend_numbers,
      multisend_numbers_loading,
      starting_responses,
      colors
    } = this.props;
    if (multisend_numbers_loading) {
      return (
        <Wrapper
          style={{
            padding: 20,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Row>
            <Spin size="small" />
            <Copy style={{ marginLeft: 5 }}>Loading...</Copy>
          </Row>
        </Wrapper>
      );
    }
    if (starting_responses.length >= 9 && multisend_numbers.length > 0) {
      return (
        <Wrapper>
          <Card style={{ marginBottom: 40 }}>
            <Wrapper
              style={{
                padding: 15,
                borderBottomWidth: 1,
                borderBottomColor: this.props.colors.border_color,
                borderBottomStyle: "solid"
              }}
            >
              <Row>
                <Wrapper style={{ flex: 1 }}>
                  <Copy>
                    <Bold>Select at least 9 saved replies to begin</Bold>
                  </Copy>
                </Wrapper>
                {this.state.selected_replies.length <
                starting_responses.length ? (
                  <Button
                    onPress={() => {
                      this.setState({
                        selected_replies: starting_responses
                      });
                    }}
                  >
                    <Copy>Select All</Copy>
                  </Button>
                ) : (
                  <Button
                    onPress={() => {
                      this.setState({
                        selected_replies: []
                      });
                    }}
                  >
                    <Copy>Deselect All</Copy>
                  </Button>
                )}
              </Row>
            </Wrapper>

            {starting_responses.map((reply, i) => {
              return (
                <Button
                  style={{
                    borderBottomWidth: 1,
                    borderBottomStyle: "solid",
                    borderBottomColor: colors.border_color
                  }}
                  onPress={() => this.checkReply(reply)}
                  key={"reply_" + i}
                >
                  <Row>
                    <Wrapper
                      style={{
                        width: 50,
                        height: 50,
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <Icon
                        icon={
                          this.isChecked(reply)
                            ? "check-box"
                            : "check-box-outline-blank"
                        }
                      />
                    </Wrapper>
                    <Wrapper style={{ flex: 1, padding: 20, paddingLeft: 10 }}>
                      <Copy>{reply.response_text}</Copy>
                      {this.renderSpamLabel(reply)}
                    </Wrapper>
                  </Row>
                </Button>
              );
            })}
          </Card>
        </Wrapper>
      );
    } else if (multisend_numbers.length == 0) {
      return (
        <Wrapper>
          <Wrapper style={{ padding: 20, paddingTop: 0 }}>
            <Copy style={{ textAlign: "center", paddingBottom: 10 }}>
              There are no numbers associated with your selected lead(s). You'll
              need to skip trace them and then start sending once you have phone
              data.
            </Copy>
            <Row style={{ justifyContent: "center" }}>
              <PillButton
                primary={true}
                onPress={() => {
                  skipTrace({
                    props: this.props,
                    use_passed_filters: true,
                    passed_filters: {
                      lead_ids: this.state.lead_ids,
                      filters: this.state.filter,
                      filter_lists: this.state.filter_lists
                    },
                    total_property_count: this.state.total_property_count,
                    onSuccess: () => {
                      this.handleBack();
                    }
                  });
                }}
              >
                Skip Trace Selected Leads
              </PillButton>
              <PillButton
                primary={false}
                onPress={this.handleBack}
                style={{ marginLeft: 0 }}
              >
                Dismiss
              </PillButton>
            </Row>
          </Wrapper>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }

  renderSendMessage() {
    return (
      <SendMessage
        {...this.props}
        started_sending={this.state.started_sending}
        multisend_number={this.state.multisend_number}
        current_message_text={this.state.current_message_text}
        selected_from_number={this.state.selected_from_number}
        updateCurrentMessageText={this.updateCurrentMessageText}
        updateCurrentFromNumber={this.updateCurrentFromNumber}
        sending_over={this.state.sending_over}
        startSending={this.startSending}
        handleBack={this.handleBack}
      />
    );
  }

  renderBody() {
    if (!this.state.started_sending) {
      return (
        <Wrapper style={{ flex: 1, overflow: "hidden" }}>
          <Scroll>
            {this.renderExplainingText()}
            {this.renderSelectMessages()}
          </Scroll>
          {this.state.selected_replies.length >= 3 ? (
            <Wrapper style={{ height: 100, position: "relative" }}>
              {this.renderSendMessage()}
            </Wrapper>
          ) : null}
        </Wrapper>
      );
    }

    return (
      <KeyboardAwarePanel
        style={{
          flex: 1,
          display: "flex"
        }}
      >
        {this.renderCompleteText()}
        {this.renderSendMessage()}
      </KeyboardAwarePanel>
    );
  }

  render() {
    return (
      <ModalContainer
        style={
          !this.props.isMobile && !this.state.sending_over
            ? {
                height: "90vh",
                overflow: "hidden",
                display: "flex",
                position: "relative"
              }
            : {}
        }
      >
        <Header
          title={
            this.state.sending_over
              ? "Sending Complete"
              : this.state.started_sending
              ? "Message " +
                this.props.multisend_current_number +
                " of " +
                this.props.multisend_total
              : "Send Text Messages"
          }
          leftButtonIcon={
            this.props.device === "desktop" ? "close" : "arrow-back"
          }
          leftButtonAction={() => {
            this.handleBack();
          }}
        />

        {this.renderBody()}
      </ModalContainer>
    );
  }
}

const mapStateToProps = ({
  auth,
  native,
  billing,
  settings,
  modal,
  message
}) => {
  const { token, user } = auth;
  const { platform, device, isMobile, isIphoneX } = native;
  const { colors } = settings;
  const { card_info, pricing, deal_credits } = billing;
  const {
    team_phone_number_groups,

    multisend_total,
    multisend_current_number,
    multisend_count_loading,
    multisend_numbers,
    multisend_numbers_loading,
    multisend_numbers_begin,
    multisend_numbers_loaded_all,
    multisend_numbers_limit,
    multisend_filters,
    starting_responses,

    conversations_search,
    conversations_filters,
    conversations_limit
  } = message;
  return {
    token,
    user,
    platform,
    device,
    isMobile,
    isIphoneX,
    colors,

    team_phone_number_groups,
    multisend_total,
    multisend_current_number,
    multisend_count_loading,
    multisend_numbers,
    multisend_numbers_loading,
    multisend_numbers_begin,
    multisend_numbers_loaded_all,
    multisend_numbers_limit,
    starting_responses,
    multisend_filters,
    card_info,
    pricing,
    deal_credits,

    conversations_search,
    conversations_filters,
    conversations_limit
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  getMultiSendNumbers,
  getMultiSendNumbersCount,
  sendMultiSendMessage,
  skipMultiSendNumber,
  updateLead,
  updateOwnerInfo,
  getConversations,
  setModal,
  toggleModal
})(MultiSendNumbers);
